import React, { useState ,useEffect, useRef } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import infoLogo from "../../../assets/images/info.png";
import warningLogo from "../../../assets/images/warning.png";
import {FormattedMessage} from "react-intl";
import { Control, LocalForm, Errors } from 'react-redux-form';

const ModalExample4 = (props) => {
  const {
    buttonLabel,
    className,
    size,
    warning,
    info,
    confirmation,
    isText,
    hasTitle,
    repos,
    changeStagingprj,
    setRepo,
    setRepos,
    jdbcname,
    setJdbcname,
    jdbcdriver,
    setJdbcdriver,
    dbversion,
    setDbversion,
    port,
    setPort,
    dbname,
    setDbname,
    dbusername,
    setDbusername,
    dbpassword,
    setDbpassword,
    dbpasswordconfirm,
    setDbpasswordconnfirm,
    jdbcdriverList,
    clickSubmitHandler,
    edit
    // LocalForm
  } = props;
  const divRef = useRef();
  const [modal, setModal] = useState(false);
  const [showmysql, setShowmysql] = useState(false);
  const [showmicrosft, setShowmicrosft] = useState(false);
  const [showall, setShowall] = useState(true);
  const [infoText, setInfoText] = useState("SQL/No SQL Data Source");
  const [warningText, setWarningText] = useState("Exception");
  const [showEditor, setShowEditor] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [showFiles, setShowFiles] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [projectName, setProjectName] = useState("");
  //const [repo, setRepo] = useState("");
  const [customer, setCustomer] = useState("");
  const [stagingrepo, setStagingrepo] = useState("");
  // const [refId, setRefId] = useState("");
  const [srclang, setSrclang] = useState("");
  const [targetLanguage, setTargetLanguage] = useState("");
  const [description, setDescription] = useState("");
  //const [jdbcname, setJdbcname] = useState("");
  // const [port, setPort] = useState("");
  // const [dbname, setDbname] = useState("");
  // const [dbusername, setDbusername] = useState("");
  // const [dbpassword, setDbpassword] = useState("");
  // const [dbpasswordconfirm, setDbpasswordconnfirm] = useState("");
  const [uploadType, setUploadType] = useState("");
  const [uploadcontent, setUploadcontent] = useState("");
  const [disableUploadBack, setDisableUploadBack] = useState("");
  const [disableupload, setDisableupload] = useState(false);
  const [validtion, setValidtion] = useState(false);
  const jobType = "Translation";
  //const [customersList, setCustomersList] = useState(["com.mysql.jdbc.Driver","com.microsoft.sqlserver.jdbc.SQLServerDriver"]);
  //const [jdbcdriverList, setJdbcdriverList] = useState(["com.mysql.jdbc.Driver","com.microsoft.sqlserver.jdbc.SQLServerDriver"]);
  // const [jdbcdriver, setJdbcdriver] = useState("");
  // const [dbversion, setDbversion] = useState("");



 const validatePort= (e)=>{

  setPort(e.target.value);
  if(/^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/.test(e.target.value)){
    setValidtion()
  }
 }

  const selectdriver = (e)=>{
    console.log(e.target.value);
    setJdbcdriver(e.target.value);
    if("com.mysql.jdbc.Driver"==e.target.value){
      setDbversion("");
      setShowmysql(true);
      setShowmicrosft(false);
      setShowall(false);
    }

    if("com.microsoft.sqlserver.jdbc.SQLServerDriver"==e.target.value){
      setDbversion("");
          setShowmicrosft(true);
          setShowmysql(false);
          setShowall(false);
    }
    
    if(""==e.target.value){
      setDbversion("");
      setShowall(true);
      setShowmicrosft(false);
      setShowmysql(false);
    }
  };

  //const toggle = () => setModal(!modal);

  const toggle = () => {setModal(!modal);
    if (!modal.isOpen){
     setTimeout(function() { 
  
       divRef.current.scrollTo(0, 0);
    
     }, 200);
    }
  }

  const close = ()=>{
    toggle();
    //  clickSubmitHandler(
    //   props.username,
    //   props.repo,
    //   srclang,
    //   targetLanguage,
    //   description,
    //   jobType,
    //   stagingrepo,
    //   customer,
                         
    // );
    changeStagingprj()
  }

  const closeback = ()=>{
    toggle();
   // changeStagingprj()
  }
  useEffect(() => {
    if(props.hasOwnProperty('setClick')){
      props.setClick(toggle);
    }
    if(props.hasOwnProperty('infoText')){
      setInfoText(props.infoText);
    }
    if(props.hasOwnProperty('warningText')){
      setWarningText(props.warningText);
    }
  }, []);

  useEffect(() => {

  }, []);

  return (

    <i>
      <Button disabled ={edit} className={edit?`button asse_uploadno`:`button asse_upload`}  style={{fontWeight:'600',fontSize:'13px',backgroundColor:"#5e7a2b", marginBottom:'5px',height:'40px',width:'95px'}} onClick={toggle}>{buttonLabel}</Button>
      <Modal isOpen={modal} toggle={toggle} className={className} style={{}} >
        {hasTitle && (
          <ModalHeader toggle={toggle}>
            {(info || confirmation) &&(<div style={{width: "450px"}}><img alt="SHIFT" src={infoLogo} className="modal_logo"/><i>{infoText}</i> </div>)}
            {warning &&(<div style={{width: "372px"}}><img alt="SHIFT" src={warningLogo} className="modal_logo"/>{warningText} </div>)}
          </ModalHeader>
        )}

       <div  ref={divRef} style={{marginLeft:'4%', height: '300px', overflow: 'auto',width:''}}>
        {/* <ModalBody style={{height: '1450px', overflow: 'auto'}}> */}
          {/* {repos.map((item,i) => (
            <div key={i}>
              <input type="checkbox" checked={item.checked} key={i} onChange={()=>{item.checked = !item.checked; setRepos(repos)}} />{' '}
              {item.value}
            </div>
          ))} */}
        
                 {/* <LocalForm style={{height: '450px'}}
                    className="form"
                    onSubmit={() =>
                      clickSubmitHandler(
                        props.username,
                        props.repo,
                        srclang,
                        targetLanguage,
                        description,
                        jobType,
                        stagingrepo,
                        customer,
                                           
                      )
                    }
                  > */}
                    <div  class='form'
                      style={{
                        marginLeft: '3%',
                        height:'100%'
                      }}
                    >

                     <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="name"
                            defaultMessage="Name"
                          />
                        </label>

                        <Control.text
                          model=".jdbcname"
                          autoFocus
                          required
                          value={jdbcname}
                         onChange={(e)=>setJdbcname(e.target.value)}
                         //onChange={(e)=>setJdbcname(jdbcname)}
                        />
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="jdbc.driver"
                            defaultMessage="JDBC Driver"
                          />
                        </label>

                        <Control.select
                          model=".jdbcdriver"
                          autoFocus
                          required
                          value={jdbcdriver}
                          onChange={selectdriver}
                        // onChange = {(e)=>{setJdbcdriver(e.target.value)}}
                        >
                           <option value="">Please select JDBC driver</option>
                              <option value="com.mysql.jdbc.Driver">com.mysql.jdbc.Driver</option>
                              <option value="com.microsoft.sqlserver.jdbc.SQLServerDriver">com.microsoft.sqlserver.jdbc.SQLServerDriver</option>
                          
                          {/* {(jdbcdriverList === "" || jdbcdriverList === null) && <option value="">Please select JDBC Driver</option>}
                          {jdbcdriverList.map(item => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))} */}
                          
                        </Control.select>
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="db.version"
                            defaultMessage="DB version"
                          />
                        </label>

                        { showmysql && ( <Control.select
                          model=".dbversion"
                          autoFocus
                          required
                          value={dbversion}
                         // onChange={selectCus}
                          onChange = {(e)=>{setDbversion(e.target.value)}}
                        >                      
                          <option value="">Please select DB version</option>
                              <option value="5.7">5.7</option>
                              <option value="8.0">8.0</option>

                          {/* {(jdbcdriverList === "" || jdbcdriverList === null) && <option value="">Please select JDBC Driver</option>}
                          {jdbcdriverList.map(item => (
                            <option key={item} value={item}>
                              {item}
                            </option> */}
                          {/* ))} */}
                        </Control.select>)}

                        { showmicrosft && ( <Control.select
                          model=".dbversion"
                          autoFocus
                          required
                          value={dbversion}
                         // onChange={selectCus}
                          onChange = {(e)=>{setDbversion(e.target.value)}}
                        >                      
                          <option value="">Please select DB version</option>
                              <option value="14.0">14.0</option>
                              <option value="15.0">15.0</option>

                        </Control.select>)}

                        { showall && ( <Control.select
                          model=".dbversion"
                          autoFocus
                          required
                          value={dbversion}
                         // onChange={selectCus}
                          onChange = {(e)=>{setDbversion(e.target.value)}}
                        >                      
                          <option value="">Please select DB version</option>
                              <option value="5.7">5.7</option>
                              <option value="8.0">8.0</option>
                              <option value="14.0">14.0</option>
                              <option value="15.0">15.0</option>

                        </Control.select>)}
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="name1"
                            defaultMessage="Host"
                          />
                        </label>

                        <Control.text
                          model=".host"
                          autoFocus
                          required
                          value="Default"
                         disabled
                        />
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="name1"
                            defaultMessage="Port"
                          />
                        </label>

                        <Control.text
                          model=".port"
                          autoFocus
                          required
                          value={port}
                         onChange={(e)=>setPort(e.target.value)}
                       // onChange={validatePort}
                         validators={{
                          
                          validPort: val => /^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/.test(val),
                          //length: val => !val || `${val}`.length < 6
          
                        }}
                        />
                      
                       < Errors
                        className="error"
                        model=".port"
                        messages={{
                        // validPort: 'Invalid port number. ',
                         //length: 'Phone Number length should be 10.'
                          }}
                        />
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="name1"
                            defaultMessage="DB Name"
                          />
                        </label>

                        <Control.text
                          model=".dbname"
                          autoFocus
                          required
                          value={dbname}
                         onChange={(e)=>setDbname(e.target.value)}
                        />
                      </fieldset>
                      <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="name1"
                            defaultMessage="User Name"
                          />
                        </label>

                        <Control.text
                          model=".dbusername"
                          autoFocus
                          required
                          value={dbusername}
                         onChange={(e)=>setDbusername(e.target.value)}
                        />
                        </fieldset>
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="name1"
                            defaultMessage="Password"
                          />
                        </label>

                        <Control.password
                          model=".dbpassword"
                          autoFocus
                          required
                          value={dbpassword}
                         onChange={(e)=>setDbpassword(e.target.value)}
                        />
                        </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="name1"
                            defaultMessage="Confirm Password"
                          />
                        </label>

                        <Control.password
                          model=".dbpasswordconfirm"
                          autoFocus
                          required
                          value={dbpasswordconfirm}
                         onChange={(e)=>setDbpasswordconnfirm(e.target.value)}
                        />
                        </fieldset>
                      </div>
                      </div>
      {/* </LocalForm>
        </ModalBody> */}
        <ModalFooter>
          {(info || warning) &&(
            <div
            className="button-container"
            style={{ textAlign: 'center' }}
          > <button
              className="button"
              style={{ marginLeft : "auto", marginRight : "70px"}}
              type="button"
              onClick={closeback}
            >
              <FormattedMessage id="run-assessment.back.button.name" defaultMessage="Back" />
            </button>

                <button disabled={jdbcname.trim()=="" || jdbcdriver=="" || dbusername==""||dbpasswordconfirm==""||dbpassword==""
                ||dbversion==""||port=="" || dbpasswordconfirm !== dbpassword || Errors.valid}
                className="button"
                style={{ marginLeft : "auto", marginRight : "124px"}}
                type="submit"
                onClick={close}
                >
                <FormattedMessage id="nav.ok" defaultMessage="OK" />
                </button>  
            </div>
          )}
        </ModalFooter>
      </Modal>
    </i>
  );
}

export default ModalExample4;



// WEBPACK FOOTER //
// ./src/components/views/Createdatafactoryupdate/popupeditjdbc.js